import clsx from 'clsx';

interface PlayerDoubleStatProps {
  className?: string;
  firstStatValue: number;
  secondStatValue: number;
  isHome: boolean;
}

const statValueClassNames =
  'min-w-[52px] text-center font-unibet font-medium text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark';

export default function PlayerDoubleStat({
  className = '',
  firstStatValue,
  secondStatValue,
  isHome,
}: PlayerDoubleStatProps) {
  return (
    <div
      className={clsx(
        'col-span-3',
        'grid',
        'grid-cols-subgrid',
        'items-center',
        'justify-center',
        'gap-0.5',
        'py-2',
        'px-0.5',
        'rounded-xl',
        {
          'bg-pmw-player-stat-home-bg': isHome,
          'bg-pmw-player-stat-away-bg': !isHome,
        },
        className,
      )}
    >
      <span className={statValueClassNames}>{firstStatValue || '-'}</span>
      <div className="h-[16px] w-[0.5px] bg-pmw-double-stat-separator" />
      <span className={statValueClassNames}>{secondStatValue || '-'}</span>
    </div>
  );
}
